import * as React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { CyNumber } from "../../../utilities/number";
import {END_OF_CPR_YEAR} from "../../../utilities/cpr";

const MonteCarloDisclosure = (props) => {
  const { standardDeviation, annualReturn, startDate } = props;
  return(
    <Grid
      container={true}
      style={{ margin: "16px 0 0" }}
      className={"monteCarloDisclosure"}
    >
      <Grid item={true} xs={12}>
        <Typography
          className={"disclosure"}
          variant={"caption"}
          paragraph={true}>
            Performance for the Cy Optimized Portfolio is net of
            underlying fund fees and expenses, but does not reflect deduction
            of the adviser fee, platform fee or custodial fees. Cy Optimized
            Portfolio performance is hypothetical, does not represent actual
            results, and is not indicative of future returns. Please refer to
            the Important Information section at the end of this presentation
            for information about the limitations of hypothetical performance,
            Monte Carlo simulations, and the calculation methodology.
          </Typography>
          <Typography
            className={"disclosure"}
            variant={"caption"}
            paragraph={true}
          >
            The Model in this report assumes a historical average portfolio return
            of { CyNumber.PercentageParser(annualReturn) } and standard deviation
            of { CyNumber.PercentageParser(standardDeviation) } from the
            period { startDate.format('MM/DD/YYYY') } through {END_OF_CPR_YEAR.format('MM/DD/YYYY')}.
          </Typography>
          <Typography
            className={"disclosure"}
            variant={"caption"}
            paragraph={true}
          >
            For recipient use only. Not for redistribution.
          </Typography>
        </Grid>
    </Grid>
  )
}
export default MonteCarloDisclosure;


// WEBPACK FOOTER //
// ./src/containers/SummaryPDF/components/MonteCarloDisclosure.jsx